;(function ($, undefined) {
    var rnn, settings, hasDefineProperty;

    // rnn namespace
    rnn = window.rnn = window.rnn || {};

    // settings (defaults)
    settings = {};

    /////////////////////////
    // Utility functions
    /////////////////////////

    function defineProperty(object, propertyName, options) {
        if (hasDefineProperty) {
            Object.defineProperty(object, propertyName, options);
        } else if (options.value) {
            object[propertyName] = options.value;
        }
    }
    rnn.defineProperty = defineProperty;

    hasDefineProperty = (function () {
        var test = {};
        if (typeof Object.defineProperty === 'function') {
            try {
                Object.defineProperty(test, 'testProp', {});
            } catch (e) {return false;}
        }else{
            return false;
        }
        return true;
    })();

    /////////////////////////
    // object extentions
    /////////////////////////

    // fastEach
    //Copyright (C) 2012 Kory Nunn & Matt Ginty

    //Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

    //The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
    Array.prototype.fastEach = function (callback) {
        for (var i = 0; i < this.length; i++) {
            if(callback(this[i], i, this)) break;
        }
    };

    // Stop fastEach from being enumerated in for...in calls
    defineProperty(Array.prototype, 'fastEach', {enumerable: false});

    /////////////////////////
    // Logging
    /////////////////////////

    rnn.logging = {};
    rnn.logging.logs = {};
    rnn.logging.log = function () {
        var args = _.toArray(arguments),
            console = window.console;

        rnn.logging.logs[new Date().toString()] = args;
        if (rnn.site.isDebug && console && console.info) {
            args.unshift('[rnn]');
            console.info(args.join(' '))
        }
    };


    /////////////////////////
    // Messaging
    /////////////////////////

    rnn.messaging = {};
    rnn.messaging.channels = {};
    rnn.messaging.subscribe = function (channel, fn, context) {
        if (!rnn.messaging.channels[channel]) {
            rnn.messaging.channels[channel] = [];
        }
        rnn.messaging.channels[channel].push({
            callback: fn,
            context: (context || window)
        });
        return this;
    };
    rnn.messaging.publish = function (channel) {
        var args;
        if (!rnn.messaging.channels[channel]) {
            return false;
        }
        args = Array.prototype.slice.call(arguments, 1);
        rnn.messaging.channels[channel].fastEach(function (subscription) {
            subscription.callback.apply(subscription.context, args);
        });
        return this;
    };

    /////////////////////////
    // Site
    /////////////////////////

    rnn.site = {};
    rnn.site.init = function (siteConfig) {
        _.extend(rnn, {site: siteConfig});
        rnn.site.network.isAU = rnn.site.network.name === 'RNN';
        rnn.site.network.isNZ = rnn.site.network.name === 'NZ RNN';
    };

    /////////////////////////
    // Helpers
    /////////////////////////

    rnn.getModule = function(target, type, subtype){
        var module = $(target).closest('[data-module]'),
            isModule = function(){
                var result = true;
                if(!module.length || !module.data('module')){
                    return false;
                }
                if(type){
                    result = result && module.data('module').type === type;
                }
                if(subtype){
                    result = result && module.data('module').subtype === subtype;
                }

                return result;
            };

        isModule(module);

        while(!isModule(module) && module.length){
            module = module.parent().closest('[data-module]');
        }

        return isModule(module) && module;
    };

    /////////////////////////
    // rnn initialisation
    /////////////////////////

    // Create the initialisation function
    rnn.init = function (siteConfig, options) {

        // Customise the settings
        _.extend(settings, options || {});

        // Initialise the site
        rnn.site.init(siteConfig);

        // Initialise modules
        rnn.modules.init();
    };

})(jQuery);
